package top.wcpe.allincore.dsl.compiler.source

/**
 * 一份待编译的源文件：路径 + 文本。
 *
 * 由 [SourceScanner] 扫描产出；后续 lex/parse 阶段直接消费 [text]。
 *
 * FR-UI-061：path 由 `java.nio.file.Path` 改为平台中立的 String（编译管线只把它当
 * 标识符做 toString/派生 screenId，从不做文件系统操作）；原 charset 字段零消费方，
 * 一并移除。JVM 侧保留 `SourceFile(Path, ...)` 顶层工厂（见 jvmMain SourceFileJvm.kt），
 * 既有调用方零改动。
 */
data class SourceFile(
    val path: String,
    val text: String,
)
